import LectureCreateContent from '../../components/admin/LectureCreateContent'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import { useLocation } from 'react-router-dom'

const LectureCreate = () => {
  const location = useLocation()
  const questionId = location.state?.questionId
  const fromPage = location.state?.fromPage || 1
  const level = location.state?.level || 1

  return (
    <AdminLayout>
      <AdminContentLayout>
        <LectureCreateContent
          questionId={questionId}
          fromPage={fromPage}
          level={level}
        />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default LectureCreate
